/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseBillingApi } from '../../base-api';
export type BillingTimeIntervalFragment = { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean };

export type BillingTermFragment = { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } };

export type BillingEntitlementFragment = { __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } };

export type BillingProvisionedUsageFragment = { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } };

export type BillingUpfrontProvisionedUsageItemFragment = { __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } };

export type BillingPlanFragment = { __typename: 'BillingPlan', tier: string, planType: Types.BillingPlanTypeEnum, planVersion: string, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }> };

export type BillingSubscriptionFragment = { __typename: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<Types.BillingOperationEnum>, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }>, tierRanking?: { __typename: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename: 'BillingMetadataItem', key: string, value: string }> };

export type BillingChangeFragment = { __typename: 'BillingScheduledSubscriptionChange', cancellation?: boolean, changeTs: number, scheduledSubscriptionChangeKey: string, schedulingPolicy: Types.BillingSubscriptionChangeSchedulingPolicyEnum, creation?: { __typename: 'BillingScheduledSubscriptionCreation', subscription: { __typename: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<Types.BillingOperationEnum>, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }>, tierRanking?: { __typename: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename: 'BillingMetadataItem', key: string, value: string }> } }, planSwitch?: { __typename: 'BillingScheduledPlanSwitch', subscription: { __typename: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<Types.BillingOperationEnum>, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }>, tierRanking?: { __typename: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename: 'BillingMetadataItem', key: string, value: string }> } }, entitlementUpdate?: { __typename: 'BillingScheduledSubscriptionEntitlementUpdate', entitlement: { __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } } }, termUpdate?: { __typename: 'BillingScheduledSubscriptionTermUpdate', term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } } } };

export type BillingMetadataItemFragment = { __typename: 'BillingMetadataItem', key: string, value: string };

export type BillingFeatureValuesFragment = { __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string };

export type BillingEntitlementUsageFragment = { __typename: 'BillingEntitlementTermUsage', feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, confirmedUsage: string, period?: Types.BillingPeriodEnum, upfrontQuantity: string };

export type BillingStatsValuesFragment = { __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string };

export type BillingMeteredDataFragment = { __typename: 'BillingUsageStatsMeteredData', timestamps: Array<string>, period: Types.BillingPeriodEnum, featureValues: Array<{ __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, carryover?: { __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string } };

export type BillingLicensedDataFragment = { __typename: 'BillingUsageStatsLicensedData', timestamps: Array<string>, featureValues: Array<{ __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }> };

export type SwitchTenantPlanMutationVariables = Types.Exact<{
  params: Types.BillingSwitchPlanInput;
}>;


export type SwitchTenantPlanMutation = { __typename: 'Mutation', switchTenantPlan: { __typename: 'BillingResponse', status: Types.BillingResponseStatusEnum } };

export type UpdateTenantSubscriptionMutationVariables = Types.Exact<{
  params: Types.BillingUpdateSubscriptionInput;
}>;


export type UpdateTenantSubscriptionMutation = { __typename: 'Mutation', updateTenantSubscription: { __typename: 'BillingResponse', status: Types.BillingResponseStatusEnum } };

export type RevokeSubscriptionChangeMutationVariables = Types.Exact<{
  params: Types.BillingRevokeScheduledSubscriptionChangeInput;
}>;


export type RevokeSubscriptionChangeMutation = { __typename: 'Mutation', revokeTenantScheduledSubscriptionChange: { __typename: 'BillingResponse', status: Types.BillingResponseStatusEnum } };

export type CancelSubscriptionMutationVariables = Types.Exact<{
  params: Types.BillingCancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename: 'Mutation', cancelTenantSubscription: { __typename: 'BillingResponse', status: Types.BillingResponseStatusEnum } };

export type CreateSubscriptionMutationVariables = Types.Exact<{
  params: Types.BillingCreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename: 'Mutation', createTenantSubscription: { __typename: 'BillingResponse', status: Types.BillingResponseStatusEnum } };

export type HandleTermsAndConditionsAcceptedForBillingMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type HandleTermsAndConditionsAcceptedForBillingMutation = { __typename: 'Mutation', handleTermsAndConditionsAccepted: { __typename: 'BillingResponse', status: Types.BillingResponseStatusEnum } };

export type ReadResalePlansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadResalePlansQuery = { __typename: 'Query', resalePlans: Array<{ __typename: 'BillingPlan', tier: string, planType: Types.BillingPlanTypeEnum, planVersion: string, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }> }> };

export type ReadTenantSubscriptionStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadTenantSubscriptionStatusQuery = { __typename: 'Query', tenantSubscriptionStatus: { __typename: 'BillingSubscriptionStatus', cancellationTs?: number, expirationTs?: number, planType?: Types.BillingPlanTypeEnum } };

export type ReadTenantSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadTenantSubscriptionQuery = { __typename: 'Query', tenantSubscription: { __typename: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<Types.BillingOperationEnum>, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }>, tierRanking?: { __typename: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename: 'BillingMetadataItem', key: string, value: string }> } };

export type ReadTenantScheduledSubscriptionChangesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadTenantScheduledSubscriptionChangesQuery = { __typename: 'Query', tenantScheduledSubscriptionChanges: Array<{ __typename: 'BillingScheduledSubscriptionChange', cancellation?: boolean, changeTs: number, scheduledSubscriptionChangeKey: string, schedulingPolicy: Types.BillingSubscriptionChangeSchedulingPolicyEnum, creation?: { __typename: 'BillingScheduledSubscriptionCreation', subscription: { __typename: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<Types.BillingOperationEnum>, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }>, tierRanking?: { __typename: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename: 'BillingMetadataItem', key: string, value: string }> } }, planSwitch?: { __typename: 'BillingScheduledPlanSwitch', subscription: { __typename: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<Types.BillingOperationEnum>, entitlements: Array<{ __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } }>, tierRanking?: { __typename: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename: 'BillingMetadataItem', key: string, value: string }> } }, entitlementUpdate?: { __typename: 'BillingScheduledSubscriptionEntitlementUpdate', entitlement: { __typename: 'BillingEntitlement', enabled: boolean, feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, resellerOps?: Array<Types.BillingOperationEnum>, usageType: Types.BillingUsageTypeEnum, provisionedUsage: { __typename: 'BillingProvisionedUsage', resellerOps?: Array<Types.BillingOperationEnum>, scope: { __typename: 'BillingScopeParams', period: Types.BillingPeriodEnum }, upfront: Array<{ __typename: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<Types.BillingOperationEnum>, proportionalQuantity?: { __typename: 'BillingProportionalQuantity', dependerFeature: Types.BillingFeatureEnum } }>, expost: { __typename: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<Types.BillingOperationEnum> } } } }, termUpdate?: { __typename: 'BillingScheduledSubscriptionTermUpdate', term: { __typename: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } } } }> };

export type ReadTenantSubscriptionTermUsageQueryVariables = Types.Exact<{
  subscriptionVersion: Types.Scalars['String']['input'];
  termReferenceTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ReadTenantSubscriptionTermUsageQuery = { __typename: 'Query', tenantSubscriptionTermUsage: { __typename: 'BillingSubscriptionTermUsage', subscriptionVersion: string, termReferenceTs: number, entitlementUsages: Array<{ __typename: 'BillingEntitlementTermUsage', feature: Types.BillingFeatureEnum, allFeatures: Array<Types.BillingFeatureEnum>, confirmedUsage: string, period?: Types.BillingPeriodEnum, upfrontQuantity: string }> } };

export type ReadTenantFeatureUsageStatsQueryVariables = Types.Exact<{
  feature: Types.BillingFeatureEnum;
  startTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ReadTenantFeatureUsageStatsQuery = { __typename: 'Query', tenantFeatureUsageStats: { __typename: 'BillingUsageStats', data:
      | { __typename: 'BillingUsageStatsLicensedData', timestamps: Array<string>, featureValues: Array<{ __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }> }
      | { __typename: 'BillingUsageStatsMeteredData', timestamps: Array<string>, period: Types.BillingPeriodEnum, featureValues: Array<{ __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, carryover?: { __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string } }
     } };

export type ReadTenantEntitlementUsageStatsQueryVariables = Types.Exact<{
  feature: Types.BillingFeatureEnum;
  startTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ReadTenantEntitlementUsageStatsQuery = { __typename: 'Query', tenantEntitlementUsageStats: { __typename: 'BillingUsageStats', data:
      | { __typename: 'BillingUsageStatsLicensedData', timestamps: Array<string>, featureValues: Array<{ __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }> }
      | { __typename: 'BillingUsageStatsMeteredData', timestamps: Array<string>, period: Types.BillingPeriodEnum, featureValues: Array<{ __typename: 'BillingUsageStatsFeatureValues', feature: Types.BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, carryover?: { __typename: 'BillingUsageStatsValues', values: Array<string>, groupId?: string } }
     } };

export type ReadTenantFeatureUsageStatsExportQueryVariables = Types.Exact<{
  feature: Types.BillingFeatureEnum;
  startTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endTs?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  dataFormat: Types.BillingDataFormatEnum;
}>;


export type ReadTenantFeatureUsageStatsExportQuery = { __typename: 'Query', tenantFeatureUsageStatsExport: { __typename: 'BillingUsageStatsExport', url?: string } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const BillingUpfrontProvisionedUsageItemFragmentDoc = new TypedDocumentString(`
    fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}
    `, {"fragmentName":"BillingUpfrontProvisionedUsageItem"});
export const BillingProvisionedUsageFragmentDoc = new TypedDocumentString(`
    fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
    fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}`, {"fragmentName":"BillingProvisionedUsage"});
export const BillingEntitlementFragmentDoc = new TypedDocumentString(`
    fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
    fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}`, {"fragmentName":"BillingEntitlement"});
export const BillingPlanFragmentDoc = new TypedDocumentString(`
    fragment BillingPlan on BillingPlan {
  __typename
  entitlements {
    __typename
    ...BillingEntitlement
  }
  tier
  planType
  planVersion
}
    fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}`, {"fragmentName":"BillingPlan"});
export const BillingTimeIntervalFragmentDoc = new TypedDocumentString(`
    fragment BillingTimeInterval on BillingTimeInterval {
  __typename
  seconds
  minutes
  hours
  days
  months
  years
  recurring
}
    `, {"fragmentName":"BillingTimeInterval"});
export const BillingTermFragmentDoc = new TypedDocumentString(`
    fragment BillingTerm on BillingTerm {
  __typename
  duration {
    __typename
    ...BillingTimeInterval
  }
  noticePeriod {
    __typename
    ...BillingTimeInterval
  }
  startTs
  expirationTs
  cancellationTs
}
    fragment BillingTimeInterval on BillingTimeInterval {
  __typename
  seconds
  minutes
  hours
  days
  months
  years
  recurring
}`, {"fragmentName":"BillingTerm"});
export const BillingMetadataItemFragmentDoc = new TypedDocumentString(`
    fragment BillingMetadataItem on BillingMetadataItem {
  __typename
  key
  value
}
    `, {"fragmentName":"BillingMetadataItem"});
export const BillingSubscriptionFragmentDoc = new TypedDocumentString(`
    fragment BillingSubscription on BillingSubscription {
  __typename
  entitlements {
    __typename
    ...BillingEntitlement
  }
  tierRanking {
    __typename
    upsaleTiers
  }
  tier
  planVersion
  subscriptionVersion
  term {
    __typename
    ...BillingTerm
  }
  metadata {
    __typename
    ...BillingMetadataItem
  }
  resellerOps
}
    fragment BillingTimeInterval on BillingTimeInterval {
  __typename
  seconds
  minutes
  hours
  days
  months
  years
  recurring
}
fragment BillingTerm on BillingTerm {
  __typename
  duration {
    __typename
    ...BillingTimeInterval
  }
  noticePeriod {
    __typename
    ...BillingTimeInterval
  }
  startTs
  expirationTs
  cancellationTs
}
fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}
fragment BillingMetadataItem on BillingMetadataItem {
  __typename
  key
  value
}`, {"fragmentName":"BillingSubscription"});
export const BillingChangeFragmentDoc = new TypedDocumentString(`
    fragment BillingChange on BillingScheduledSubscriptionChange {
  __typename
  cancellation
  changeTs
  scheduledSubscriptionChangeKey
  creation {
    __typename
    subscription {
      __typename
      ...BillingSubscription
    }
  }
  planSwitch {
    __typename
    subscription {
      __typename
      ...BillingSubscription
    }
  }
  entitlementUpdate {
    __typename
    entitlement {
      __typename
      ...BillingEntitlement
    }
  }
  termUpdate {
    __typename
    term {
      __typename
      ...BillingTerm
    }
  }
  schedulingPolicy
}
    fragment BillingTimeInterval on BillingTimeInterval {
  __typename
  seconds
  minutes
  hours
  days
  months
  years
  recurring
}
fragment BillingTerm on BillingTerm {
  __typename
  duration {
    __typename
    ...BillingTimeInterval
  }
  noticePeriod {
    __typename
    ...BillingTimeInterval
  }
  startTs
  expirationTs
  cancellationTs
}
fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}
fragment BillingSubscription on BillingSubscription {
  __typename
  entitlements {
    __typename
    ...BillingEntitlement
  }
  tierRanking {
    __typename
    upsaleTiers
  }
  tier
  planVersion
  subscriptionVersion
  term {
    __typename
    ...BillingTerm
  }
  metadata {
    __typename
    ...BillingMetadataItem
  }
  resellerOps
}
fragment BillingMetadataItem on BillingMetadataItem {
  __typename
  key
  value
}`, {"fragmentName":"BillingChange"});
export const BillingEntitlementUsageFragmentDoc = new TypedDocumentString(`
    fragment BillingEntitlementUsage on BillingEntitlementTermUsage {
  __typename
  feature
  allFeatures
  confirmedUsage
  period
  upfrontQuantity
}
    `, {"fragmentName":"BillingEntitlementUsage"});
export const BillingFeatureValuesFragmentDoc = new TypedDocumentString(`
    fragment BillingFeatureValues on BillingUsageStatsFeatureValues {
  __typename
  feature
  values
  groupId
}
    `, {"fragmentName":"BillingFeatureValues"});
export const BillingStatsValuesFragmentDoc = new TypedDocumentString(`
    fragment BillingStatsValues on BillingUsageStatsValues {
  __typename
  values
  groupId
}
    `, {"fragmentName":"BillingStatsValues"});
export const BillingMeteredDataFragmentDoc = new TypedDocumentString(`
    fragment BillingMeteredData on BillingUsageStatsMeteredData {
  __typename
  timestamps
  period
  featureValues {
    __typename
    ...BillingFeatureValues
  }
  upfront {
    __typename
    ...BillingStatsValues
  }
  total {
    __typename
    ...BillingStatsValues
  }
  carryover {
    __typename
    ...BillingStatsValues
  }
}
    fragment BillingFeatureValues on BillingUsageStatsFeatureValues {
  __typename
  feature
  values
  groupId
}
fragment BillingStatsValues on BillingUsageStatsValues {
  __typename
  values
  groupId
}`, {"fragmentName":"BillingMeteredData"});
export const BillingLicensedDataFragmentDoc = new TypedDocumentString(`
    fragment BillingLicensedData on BillingUsageStatsLicensedData {
  __typename
  timestamps
  featureValues {
    __typename
    ...BillingFeatureValues
  }
  upfront {
    __typename
    ...BillingStatsValues
  }
  total {
    __typename
    ...BillingStatsValues
  }
}
    fragment BillingFeatureValues on BillingUsageStatsFeatureValues {
  __typename
  feature
  values
  groupId
}
fragment BillingStatsValues on BillingUsageStatsValues {
  __typename
  values
  groupId
}`, {"fragmentName":"BillingLicensedData"});
export const SwitchTenantPlanDocument = new TypedDocumentString(`
    mutation SwitchTenantPlan($params: BillingSwitchPlanInput!) {
  __typename
  switchTenantPlan(params: $params) {
    __typename
    status
  }
}
    `);
export const UpdateTenantSubscriptionDocument = new TypedDocumentString(`
    mutation UpdateTenantSubscription($params: BillingUpdateSubscriptionInput!) {
  __typename
  updateTenantSubscription(params: $params) {
    __typename
    status
  }
}
    `);
export const RevokeSubscriptionChangeDocument = new TypedDocumentString(`
    mutation RevokeSubscriptionChange($params: BillingRevokeScheduledSubscriptionChangeInput!) {
  __typename
  revokeTenantScheduledSubscriptionChange(params: $params) {
    __typename
    status
  }
}
    `);
export const CancelSubscriptionDocument = new TypedDocumentString(`
    mutation CancelSubscription($params: BillingCancelSubscriptionInput!) {
  __typename
  cancelTenantSubscription(params: $params) {
    __typename
    status
  }
}
    `);
export const CreateSubscriptionDocument = new TypedDocumentString(`
    mutation CreateSubscription($params: BillingCreateSubscriptionInput!) {
  __typename
  createTenantSubscription(params: $params) {
    __typename
    status
  }
}
    `);
export const HandleTermsAndConditionsAcceptedForBillingDocument = new TypedDocumentString(`
    mutation HandleTermsAndConditionsAcceptedForBilling {
  __typename
  handleTermsAndConditionsAccepted {
    __typename
    status
  }
}
    `);
export const ReadResalePlansDocument = new TypedDocumentString(`
    query ReadResalePlans {
  __typename
  resalePlans {
    __typename
    ...BillingPlan
  }
}
    fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}
fragment BillingPlan on BillingPlan {
  __typename
  entitlements {
    __typename
    ...BillingEntitlement
  }
  tier
  planType
  planVersion
}`);
export const ReadTenantSubscriptionStatusDocument = new TypedDocumentString(`
    query ReadTenantSubscriptionStatus {
  __typename
  tenantSubscriptionStatus {
    __typename
    cancellationTs
    expirationTs
    planType
  }
}
    `);
export const ReadTenantSubscriptionDocument = new TypedDocumentString(`
    query ReadTenantSubscription {
  __typename
  tenantSubscription {
    __typename
    ...BillingSubscription
  }
}
    fragment BillingTimeInterval on BillingTimeInterval {
  __typename
  seconds
  minutes
  hours
  days
  months
  years
  recurring
}
fragment BillingTerm on BillingTerm {
  __typename
  duration {
    __typename
    ...BillingTimeInterval
  }
  noticePeriod {
    __typename
    ...BillingTimeInterval
  }
  startTs
  expirationTs
  cancellationTs
}
fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}
fragment BillingSubscription on BillingSubscription {
  __typename
  entitlements {
    __typename
    ...BillingEntitlement
  }
  tierRanking {
    __typename
    upsaleTiers
  }
  tier
  planVersion
  subscriptionVersion
  term {
    __typename
    ...BillingTerm
  }
  metadata {
    __typename
    ...BillingMetadataItem
  }
  resellerOps
}
fragment BillingMetadataItem on BillingMetadataItem {
  __typename
  key
  value
}`);
export const ReadTenantScheduledSubscriptionChangesDocument = new TypedDocumentString(`
    query ReadTenantScheduledSubscriptionChanges {
  __typename
  tenantScheduledSubscriptionChanges {
    __typename
    ...BillingChange
  }
}
    fragment BillingTimeInterval on BillingTimeInterval {
  __typename
  seconds
  minutes
  hours
  days
  months
  years
  recurring
}
fragment BillingTerm on BillingTerm {
  __typename
  duration {
    __typename
    ...BillingTimeInterval
  }
  noticePeriod {
    __typename
    ...BillingTimeInterval
  }
  startTs
  expirationTs
  cancellationTs
}
fragment BillingEntitlement on BillingEntitlement {
  __typename
  enabled
  feature
  allFeatures
  provisionedUsage {
    __typename
    ...BillingProvisionedUsage
  }
  resellerOps
  usageType
}
fragment BillingProvisionedUsage on BillingProvisionedUsage {
  __typename
  scope {
    __typename
    period
  }
  upfront {
    __typename
    ...BillingUpfrontProvisionedUsageItem
  }
  expost {
    __typename
    enabled
    resellerOps
  }
  resellerOps
}
fragment BillingUpfrontProvisionedUsageItem on BillingUpfrontProvisionedUsageItem {
  __typename
  itemId
  fixedQuantity
  packageSize
  proportionalQuantity {
    __typename
    dependerFeature
  }
  resellerOps
}
fragment BillingSubscription on BillingSubscription {
  __typename
  entitlements {
    __typename
    ...BillingEntitlement
  }
  tierRanking {
    __typename
    upsaleTiers
  }
  tier
  planVersion
  subscriptionVersion
  term {
    __typename
    ...BillingTerm
  }
  metadata {
    __typename
    ...BillingMetadataItem
  }
  resellerOps
}
fragment BillingChange on BillingScheduledSubscriptionChange {
  __typename
  cancellation
  changeTs
  scheduledSubscriptionChangeKey
  creation {
    __typename
    subscription {
      __typename
      ...BillingSubscription
    }
  }
  planSwitch {
    __typename
    subscription {
      __typename
      ...BillingSubscription
    }
  }
  entitlementUpdate {
    __typename
    entitlement {
      __typename
      ...BillingEntitlement
    }
  }
  termUpdate {
    __typename
    term {
      __typename
      ...BillingTerm
    }
  }
  schedulingPolicy
}
fragment BillingMetadataItem on BillingMetadataItem {
  __typename
  key
  value
}`);
export const ReadTenantSubscriptionTermUsageDocument = new TypedDocumentString(`
    query ReadTenantSubscriptionTermUsage($subscriptionVersion: String!, $termReferenceTs: Int) {
  __typename
  tenantSubscriptionTermUsage(
    params: {subscriptionVersion: $subscriptionVersion, termReferenceTs: $termReferenceTs}
  ) {
    __typename
    entitlementUsages {
      __typename
      ...BillingEntitlementUsage
    }
    subscriptionVersion
    termReferenceTs
  }
}
    fragment BillingEntitlementUsage on BillingEntitlementTermUsage {
  __typename
  feature
  allFeatures
  confirmedUsage
  period
  upfrontQuantity
}`);
export const ReadTenantFeatureUsageStatsDocument = new TypedDocumentString(`
    query ReadTenantFeatureUsageStats($feature: BillingFeatureEnum!, $startTs: Int, $endTs: Int) {
  __typename
  tenantFeatureUsageStats(
    params: {feature: $feature, minReferenceTs: $startTs, maxReferenceTs: $endTs}
  ) {
    __typename
    data {
      __typename
      ...BillingMeteredData
      ...BillingLicensedData
    }
  }
}
    fragment BillingFeatureValues on BillingUsageStatsFeatureValues {
  __typename
  feature
  values
  groupId
}
fragment BillingStatsValues on BillingUsageStatsValues {
  __typename
  values
  groupId
}
fragment BillingMeteredData on BillingUsageStatsMeteredData {
  __typename
  timestamps
  period
  featureValues {
    __typename
    ...BillingFeatureValues
  }
  upfront {
    __typename
    ...BillingStatsValues
  }
  total {
    __typename
    ...BillingStatsValues
  }
  carryover {
    __typename
    ...BillingStatsValues
  }
}
fragment BillingLicensedData on BillingUsageStatsLicensedData {
  __typename
  timestamps
  featureValues {
    __typename
    ...BillingFeatureValues
  }
  upfront {
    __typename
    ...BillingStatsValues
  }
  total {
    __typename
    ...BillingStatsValues
  }
}`);
export const ReadTenantEntitlementUsageStatsDocument = new TypedDocumentString(`
    query ReadTenantEntitlementUsageStats($feature: BillingFeatureEnum!, $startTs: Int, $endTs: Int) {
  __typename
  tenantEntitlementUsageStats(
    params: {feature: $feature, minReferenceTs: $startTs, maxReferenceTs: $endTs}
  ) {
    __typename
    data {
      __typename
      ...BillingMeteredData
      ...BillingLicensedData
    }
  }
}
    fragment BillingFeatureValues on BillingUsageStatsFeatureValues {
  __typename
  feature
  values
  groupId
}
fragment BillingStatsValues on BillingUsageStatsValues {
  __typename
  values
  groupId
}
fragment BillingMeteredData on BillingUsageStatsMeteredData {
  __typename
  timestamps
  period
  featureValues {
    __typename
    ...BillingFeatureValues
  }
  upfront {
    __typename
    ...BillingStatsValues
  }
  total {
    __typename
    ...BillingStatsValues
  }
  carryover {
    __typename
    ...BillingStatsValues
  }
}
fragment BillingLicensedData on BillingUsageStatsLicensedData {
  __typename
  timestamps
  featureValues {
    __typename
    ...BillingFeatureValues
  }
  upfront {
    __typename
    ...BillingStatsValues
  }
  total {
    __typename
    ...BillingStatsValues
  }
}`);
export const ReadTenantFeatureUsageStatsExportDocument = new TypedDocumentString(`
    query ReadTenantFeatureUsageStatsExport($feature: BillingFeatureEnum!, $startTs: Int, $endTs: Int, $dataFormat: BillingDataFormatEnum!) {
  __typename
  tenantFeatureUsageStatsExport(
    params: {feature: $feature, minReferenceTs: $startTs, maxReferenceTs: $endTs, dataFormat: $dataFormat}
  ) {
    __typename
    url
  }
}
    `);

const injectedRtkApi = baseBillingApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    SwitchTenantPlan: build.mutation<Types.SwitchTenantPlanMutation, Types.SwitchTenantPlanMutationVariables>({
      query: (variables) => ({ document: SwitchTenantPlanDocument as unknown as string, variables })
    }),
    UpdateTenantSubscription: build.mutation<Types.UpdateTenantSubscriptionMutation, Types.UpdateTenantSubscriptionMutationVariables>({
      query: (variables) => ({ document: UpdateTenantSubscriptionDocument as unknown as string, variables })
    }),
    RevokeSubscriptionChange: build.mutation<Types.RevokeSubscriptionChangeMutation, Types.RevokeSubscriptionChangeMutationVariables>({
      query: (variables) => ({ document: RevokeSubscriptionChangeDocument as unknown as string, variables })
    }),
    CancelSubscription: build.mutation<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>({
      query: (variables) => ({ document: CancelSubscriptionDocument as unknown as string, variables })
    }),
    CreateSubscription: build.mutation<Types.CreateSubscriptionMutation, Types.CreateSubscriptionMutationVariables>({
      query: (variables) => ({ document: CreateSubscriptionDocument as unknown as string, variables })
    }),
    HandleTermsAndConditionsAcceptedForBilling: build.mutation<Types.HandleTermsAndConditionsAcceptedForBillingMutation, Types.HandleTermsAndConditionsAcceptedForBillingMutationVariables | void>({
      query: (variables) => ({ document: HandleTermsAndConditionsAcceptedForBillingDocument as unknown as string, variables })
    }),
    ReadResalePlans: build.query<Types.ReadResalePlansQuery, Types.ReadResalePlansQueryVariables | void>({
      query: (variables) => ({ document: ReadResalePlansDocument as unknown as string, variables })
    }),
    ReadTenantSubscriptionStatus: build.query<Types.ReadTenantSubscriptionStatusQuery, Types.ReadTenantSubscriptionStatusQueryVariables | void>({
      query: (variables) => ({ document: ReadTenantSubscriptionStatusDocument as unknown as string, variables })
    }),
    ReadTenantSubscription: build.query<Types.ReadTenantSubscriptionQuery, Types.ReadTenantSubscriptionQueryVariables | void>({
      query: (variables) => ({ document: ReadTenantSubscriptionDocument as unknown as string, variables })
    }),
    ReadTenantScheduledSubscriptionChanges: build.query<Types.ReadTenantScheduledSubscriptionChangesQuery, Types.ReadTenantScheduledSubscriptionChangesQueryVariables | void>({
      query: (variables) => ({ document: ReadTenantScheduledSubscriptionChangesDocument as unknown as string, variables })
    }),
    ReadTenantSubscriptionTermUsage: build.query<Types.ReadTenantSubscriptionTermUsageQuery, Types.ReadTenantSubscriptionTermUsageQueryVariables>({
      query: (variables) => ({ document: ReadTenantSubscriptionTermUsageDocument as unknown as string, variables })
    }),
    ReadTenantFeatureUsageStats: build.query<Types.ReadTenantFeatureUsageStatsQuery, Types.ReadTenantFeatureUsageStatsQueryVariables>({
      query: (variables) => ({ document: ReadTenantFeatureUsageStatsDocument as unknown as string, variables })
    }),
    ReadTenantEntitlementUsageStats: build.query<Types.ReadTenantEntitlementUsageStatsQuery, Types.ReadTenantEntitlementUsageStatsQueryVariables>({
      query: (variables) => ({ document: ReadTenantEntitlementUsageStatsDocument as unknown as string, variables })
    }),
    ReadTenantFeatureUsageStatsExport: build.query<Types.ReadTenantFeatureUsageStatsExportQuery, Types.ReadTenantFeatureUsageStatsExportQueryVariables>({
      query: (variables) => ({ document: ReadTenantFeatureUsageStatsExportDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useSwitchTenantPlanMutation, useUpdateTenantSubscriptionMutation, useRevokeSubscriptionChangeMutation, useCancelSubscriptionMutation, useCreateSubscriptionMutation, useHandleTermsAndConditionsAcceptedForBillingMutation, useReadResalePlansQuery, useLazyReadResalePlansQuery, useReadTenantSubscriptionStatusQuery, useLazyReadTenantSubscriptionStatusQuery, useReadTenantSubscriptionQuery, useLazyReadTenantSubscriptionQuery, useReadTenantScheduledSubscriptionChangesQuery, useLazyReadTenantScheduledSubscriptionChangesQuery, useReadTenantSubscriptionTermUsageQuery, useLazyReadTenantSubscriptionTermUsageQuery, useReadTenantFeatureUsageStatsQuery, useLazyReadTenantFeatureUsageStatsQuery, useReadTenantEntitlementUsageStatsQuery, useLazyReadTenantEntitlementUsageStatsQuery, useReadTenantFeatureUsageStatsExportQuery, useLazyReadTenantFeatureUsageStatsExportQuery } = injectedRtkApi;

